/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class AgentCompatibilitySupportLevelEnum.
* @enum {}
* @readonly
*/
export default class AgentCompatibilitySupportLevelEnum {
    
        /**
         * value: "優先"
         * @const
         */
        "優先" = "優先";

    
        /**
         * value: "普通"
         * @const
         */
        "普通" = "普通";

    
        /**
         * value: "非優先"
         * @const
         */
        "非優先" = "非優先";

    

    /**
    * Returns a <code>AgentCompatibilitySupportLevelEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/AgentCompatibilitySupportLevelEnum} The enum <code>AgentCompatibilitySupportLevelEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

